import { useEffect, useState } from "react";

function diff(targetISO) {
  const target = new Date(targetISO).getTime();
  const now = Date.now();
  const total = Math.max(0, target - now);
  const days = Math.floor(total / 86400000);
  const hours = Math.floor((total % 86400000) / 3600000);
  const minutes = Math.floor((total % 3600000) / 60000);
  const seconds = Math.floor((total % 60000) / 1000);
  return { total, days, hours, minutes, seconds };
}

function Unit({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <span
        className="font-serif-display text-3xl sm:text-4xl text-primary-gold tabular-nums leading-none"
        data-testid={`countdown-${label.toLowerCase()}`}
      >
        {String(value).padStart(2, "0")}
      </span>
      <span className="font-mono-ui text-[9px] uppercase tracking-[0.25em] text-soft mt-2">
        {label}
      </span>
    </div>
  );
}

export default function Countdown({ targetISO }) {
  const [t, setT] = useState(() => diff(targetISO));

  useEffect(() => {
    const id = setInterval(() => setT(diff(targetISO)), 1000);
    return () => clearInterval(id);
  }, [targetISO]);

  if (t.total <= 0) {
    return (
      <p
        data-testid="countdown-live"
        className="font-mono-ui text-sm uppercase tracking-[0.25em] text-primary-gold"
      >
        Out now — refresh to grab it.
      </p>
    );
  }

  return (
    <div className="flex items-end gap-5 sm:gap-7" data-testid="countdown">
      <Unit value={t.days} label="Days" />
      <span className="font-serif-display text-2xl text-soft/40 pb-3">:</span>
      <Unit value={t.hours} label="Hours" />
      <span className="font-serif-display text-2xl text-soft/40 pb-3">:</span>
      <Unit value={t.minutes} label="Mins" />
      <span className="font-serif-display text-2xl text-soft/40 pb-3">:</span>
      <Unit value={t.seconds} label="Secs" />
    </div>
  );
}
